import config from '@/config'
import { IEventBus } from '@/contracts/core/event/interface/IEventBus'
import { Provider } from '@/contracts/core/provider/entity/Provider'
import { EventBusV1 } from '@/core/event/v1/EventBusV1'

class EventProvider extends Provider<IEventBus> {
  realizations: Record<string, IEventBus> = {
    v1: new EventBusV1(),
  }
}

const instance: { module: IEventBus | null } = { module: null }

export function EventProviderModule(): IEventBus {
  if (!instance.module) {
    instance.module = new EventProvider().module(config.event.version)
  }

  return instance.module
}
